import { createSlice } from '@reduxjs/toolkit';

export const reportSlice = createSlice({
  name: 'reports',
  initialState: {
    data: {},
  },
  reducers: {
    setReports: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setReports } = reportSlice.actions;

export const selectReports = (state) => state.reports.data;

export default reportSlice.reducer;
